import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

export default function data({ model, deleteEvent, editEvent }) {
  model = model ?? [];

  const Overall = ({ name, id }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <div>
        <button code={"btnEdit" + id} onClick={() => editEvent(`${id}`)}
          style={{ border: 0, backgroundColor: 'transparent' }}>
          <MDBadge
            badgeContent="Sửa"
            color="success"
            variant="gradient"
            size="sm"
          />
        </button>
        <div style={{ height: 4 }} />
        <button
          style={{ border: 0, backgroundColor: 'transparent' }}
          code={"btnDelete" + id}
          onClick={() => {
            deleteEvent(`${id}`);
          }}
        >
          <MDBadge
            badgeContent="Xóa"
            color="warning"
            variant="gradient"
            size="sm"
          />
        </button>
      </div>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{id}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const Description = ({ description }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  );

  const rows = [];

  model.forEach((item) => {
    rows.push({
      overall: <Overall name={item.name} id={item.id ?? 0} />,
      description: <Description description={item.description} />,
    });
  });

  return {
    columns: [
      { Header: "Mục", accessor: "overall", width: "45%", align: "left" },
      { Header: "Mô tả", accessor: "description", align: "left" },
    ],
    rows: rows,
  };
}
